import React from "react";
// import Home from "../pages/home";
import Page from "@jumbo/shared/Page";
import NotFound from "app/pages/404";
import { profileRoute } from "./Profile";
import { storeRoute } from "./Store";
import { historyRoute } from "./Transaction";
import Login from "app/pages/Auth/Login";
import SoloPage from "app/layouts/solo-page/SoloPage";
import { homeRoute } from "./Home";
import AuthenticateAndRolesMiddleware from "./Middleware";
import AuthenticateLoginMiddleware from "./Middleware/HomePage";

/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [
    // {
    //     path: "/",
    //     // element: <Page component={NotFound} />
    // },
    {
        middleware: [
            {
                element: AuthenticateLoginMiddleware,
                fallbackPath: "/",
            },
        ],
        routes: [
            {
                path: `/login`,
                element: <Page component={Login} />,
            },
        ],
    },
    {
        path: "*",
        element: <Page component={NotFound} />
    },
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
    ...homeRoute,
    ...profileRoute,
    ...storeRoute,
    ...historyRoute,
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [];


const routes = [
    ...routesForPublic,
    ...routesForAuthenticatedOnly,
    ...routesForNotAuthenticatedOnly,
];

export { routes as default, routesForPublic, routesForNotAuthenticatedOnly, routesForAuthenticatedOnly };